import { aidCatalog, getAidInfo } from '@spazious/dollhouse-assets';
import { useTranslate } from '@spazious/dollhouse-i18n';

import { useDeviceInfo } from './useDeviceInfo';

/**
 * Get the aid info for a specific aid and translate it
 */
export const useAidTooltipData = (): ((id: keyof typeof aidCatalog) => {
  title: string;
  description: string;
  src: string;
  poster: string;
}) => {
  const translate = useTranslate();
  const isMobile = useDeviceInfo((state) => state.isMobile);

  return (id) => {
    const info = getAidInfo(id);

    return {
      ...info,
      // i18n-extract-disable
      title: translate(info.title),
      // i18n-extract-disable
      description: translate(info.description),
      disabled: isMobile,
    };
  };
};
